import React from "react";

const ToggleOption = ({
  trueValue,
  falseValue,
  fixedAmount,
  handleSwitchT,
  handleSwitchF,
  toggleType,
  handleSwitchOne,
  handleSwitchTwo,
  handleSwitchThree,
  handleSwitchFourth,
  firstValue,
  secondValue,
  thirdValue,
  fourthValue,
  activeBtn,
}) => {
  return (
    <>
      {toggleType === "double" ? (
        <div className="flex w-full min-w-[250px] bg-neutral-20 h-10 rounded-v-md p-1 gap-1">
          <div
            onClick={handleSwitchT}
            className={` ${fixedAmount ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer   `}
          >
            {trueValue}
          </div>

          <div
            onClick={handleSwitchF}
            className={` ${!fixedAmount ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
          >
            {falseValue}
          </div>
        </div>
      ) : null}

      {toggleType === "triple" ? (
        <div className="flex w-full bg-neutral-20 h-10 rounded-v-md p-1 gap-1">
          <div
            onClick={handleSwitchOne}
            className={` ${activeBtn === "one" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer   `}
          >
            {firstValue}
          </div>

          <div
            onClick={handleSwitchTwo}
            className={` ${activeBtn === "two" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
          >
            {secondValue}
          </div>
          <div
            onClick={handleSwitchThree}
            className={` ${activeBtn === "three" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
          >
            {thirdValue}
          </div>
        </div>
      ) : null}

      {toggleType === "four" ? (
        <div className="flex w-full bg-neutral-20 h-10 rounded-v-md p-1 gap-1">
          <div
            onClick={handleSwitchOne}
            className={` ${activeBtn === "one" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer   `}
          >
            {firstValue}
          </div>

          <div
            onClick={handleSwitchTwo}
            className={` ${activeBtn === "two" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
          >
            {secondValue}
          </div>
          <div
            onClick={handleSwitchThree}
            className={` ${activeBtn === "three" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
          >
            {thirdValue}
          </div>
          <div
            onClick={handleSwitchFourth}
            className={` ${activeBtn === "four" ? "bg-neutral-00" : null} w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
          >
            {fourthValue}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ToggleOption;

{
  /* <div className="flex w-[121px] bg-neutral-20 h-10 rounded-v-md p-1 gap-1">
<div
  onClick={handleFixedAmount}
  className={` ${
    fixedAmount ? "bg-neutral-00" : "bg-neutral-20"
  } w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
>
  ثابت
</div>

<div
  onClick={handleChanging}
  className={` ${
    changing ? "bg-neutral-00" : "bg-neutral-20"
  } w-1/2  rounded-v-md flex justify-center items-center text-title-xs-regular cursor-pointer`}
>
  متغیر
</div>

</div> */
}
